import React from 'react'
import Skeleton from '@mui/material/Skeleton'

/**
 * Skeleton to be displayed when image is loading
 */
const MediaSkeleton = () => <Skeleton variant='rectangular' height={180} />

export default MediaSkeleton
